import { FC } from 'react';
import { Footer } from 'layouts/Footer';
import Header from 'layouts/Header';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import { ReCaptchaPage } from 'pages/ReCAPTCHA';
import { getIsAuth } from 'redux/reducers/auth/selectors';
import { useLocation, useParams } from 'react-router';
import queryString from 'query-string';
import { PATHS } from 'routes/constants';
import { TPageProps } from './types';

// ==========================================:
export const Page: FC<TPageProps> = ({ children, title }) => {
	const isAuth = useSelector(getIsAuth);

	const { search } = useLocation();
	const navigateParams = queryString.parse(search);
	console.log('navigateParams', navigateParams);
	console.log('search', search);
	const params = useParams<{ productTypeId?: string }>();
	console.log('params', params);
	console.log('params', params.productTypeId);

	if (!isAuth && params.productTypeId) {
		return <ReCaptchaPage />;
	}

	return (
		<div className="wrapper">
			<Helmet>
				<title>{title}</title>
			</Helmet>

			<Header />
			<main className="main">
				<div className="main-content">{children}</div>
			</main>
			<Footer />
		</div>
	);
};
